<template>
  <section class="section section-lg pt-lg-0 mt--350">
    <div class="container">
      <div class="text-center">
        <h3>
          Dokumentasi Pelayanan
          <!-- <span class="font-weight-light">, 27</span> -->
        </h3>
        <!-- <div class="h6 mt-4">
                <i class="ni business_briefcase-24 mr-2"></i>Solution Manager -
                Creative Tim Officer
              </div>
              <div>
                <i class="ni education_hat mr-2"></i>University of Computer
                Science
              </div> -->
      </div>
      <br />
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row row-grid">
            <div class="col-lg-1"></div>
            <div class="col-lg-11">
              <div class="col-lg-10 mb-lg-auto">
                <div class="rounded shadow-lg overflow-hidden">
                  <b-carousel id="carousel1" controls indicators>
                    <!-- Text slides with image -->
                    <b-carousel-slide
                      v-for="doc in laporan"
                      :key="doc"
                      :img-src="doc.img"
                    ></b-carousel-slide>
                    <!-- <b-carousel-slide
                      img-src="img/car/car1.jpg"
                    ></b-carousel-slide>
                    <b-carousel-slide
                      img-src="img/car/car2.jpg"
                    ></b-carousel-slide>
                    <b-carousel-slide
                      img-src="img/car/car3.jpg"
                    ></b-carousel-slide> -->
                  </b-carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
const axios = require("axios");

export default {
  components: {
    BCarousel,
    BCarouselSlide,
  },
  data() {
    return {
      laporan: [
        { img: "coba", name: "lukman" },
        { img: "", name: "eka" },
        { img: "cari", name: "ara" },
        { img: "joko", name: "arifandhi" },
        { img: "", name: "tina" },
        { img: "wiwik", name: "susi" },
      ],
    };
  },
  methods: {
    fetchAllData: function() {
      let self = this;

      axios
        .post("action.php", {
          action: "documentation",
        })
        .then(function(response) {
          self.laporan = response.data;
        });
    },
  },
  created: function() {
    let self = this;

    self.fetchAllData();
  },
};
</script>
